import { BaseService } from '../../infra/base.service'
import type { TaxParamEntity } from './tax-param.entity'
import type { TaxParamsRepository } from './tax-params.repository'

export class TaxParamsService extends BaseService<TaxParamEntity> {
    constructor(private rep: TaxParamsRepository) {
        super(rep)
    }
}
